define('app/views/baseview',['require'],function(require){

  var BaseView = Backbone.View.extend({

    view: 'baseview',
    parent: null,
    children: {},
    assets: [],
    assetsLoaded: 0,
    loaded: false,

    options: {},
    defaults: {},

    initialize: function(options){
      Backbone.View.prototype.initialize.call(this, options);

      _.bindAll(this,
        'beforeShow',
        'afterShow',
        'beforeHide',
        'afterHide',
        'beforeRender',
        'afterRender',
        'onResize',
        'onAssetLoaded',
        'onViewLoaded'
      );

      options = (options || {});

      if(options.el){
        this.options = $.extend({}, this.defaults, (this.$el.data() || {}));
      } else if(options.data){
        this.options = $.extend({}, this.defaults, (options.data || {}));
      } else {
        this.options = $.extend({}, this.defaults);
      }

      this.show = _.wrap(this.show, function(show){
        this.beforeShow.call(this);
        show.call(this);
        return this;
      });

      this.hide = _.wrap(this.hide, function(hide){
        this.beforeHide.call(this);
        hide.call(this);
        return this;
      });

      this.render = _.wrap(this.render, function(render){
        this.beforeRender.call(this);
        render.call(this);
        this.afterRender.call(this);
        return this;
      });

      $(window).resize(_.throttle(this.onResize, 100));

      //store reference to this view instance on this views element
      this.$el.data('instance', this);

      if(this.model){
        this.model.on('change', _.bind(this.render, this));
      }
    },

    reset: function(){

    },

    option: function(key, value){
      if(value){
        this.options[key] = value;
      } else {
        return this.options[key];
      }
    },

    preload: function(){
      this.trigger(BaseView.BEFORE_LOADED);

      var onAssetLoaded = _.bind(this.onAssetLoaded, this);
      var onViewLoaded = _.bind(this.onViewLoaded, this);

      if(this.loaded || this.assets.length == 0){
        onViewLoaded();
        return this;
      } else if(this.assets.length) {
        //if theres more than one asset to load, add a deferred promise for when they all complete
        if (this.assets.length > 0) {
          $.when.apply($, _.map(this.assets, function (asset) { return $.get(asset, onAssetLoaded); })).always(onViewLoaded);
        }
      }

      return this;
    },

    show: function(){
      this.$el.show();
      this.afterShow();
    },

    hide: function(){
      this.$el.hide();
      this.afterShow();
    },

    render: function(){
      if(this.view && dust && dust.cache[this.view]){
        //render the dust template
        var view = this.view;
        var html = null;
        dust.render(view, this.model ? this.model.toJSON() : this, function(err, out){
          if(err){
            console.log('there was an error rendering the view: ' + view);
            console.log(err);
          } else {
            html = out;
          }
        });

        //set this view's element to the rendered template
        this.setElement($(html));
        this.$el.data('instance', this);
      } else {
        console.log('dust could not find a cached template for the view: ' + this.view);
      }

      window.iws.site.initViews(this.$el);

      return this;
    },

    beforeShow: function(){
      this.trigger(BaseView.BEFORE_SHOW, this);
    },

    afterShow: function(){
      this.trigger(BaseView.AFTER_SHOW, this);
    },

    beforeHide: function(){
      this.trigger(BaseView.BEFORE_HIDE, this);
    },

    afterHide: function(){
      this.trigger(BaseView.AFTER_HIDE, this);
    },

    beforeRender: function(){
      this.trigger(BaseView.BEFORE_RENDER, this);
    },

    afterRender: function(){
      this.trigger(BaseView.AFTER_RENDER, this);
      this.onResize();
    },

    onResize: function(e){
    },

    onAssetLoaded: function(){
      this.assetsLoaded++;
      var progress = this.assetsLoaded / this.assets.length;
      this.trigger(BaseView.PROGRESS, this, progress);
    },

    onViewLoaded: function(){
      this.loaded = true;
      this.trigger(BaseView.AFTER_LOADED, this);
    }

  });

  BaseView.extend = function(subview) {
    var View = Backbone.View.extend.apply(this, arguments);
    View.prototype.defaults = _.extend({}, this.prototype.defaults, subview.defaults);
    View.prototype.events = _.extend({}, this.prototype.events, subview.events);
    window.iws.viewManager.register(subview.view, View);
    return View;
  };

  BaseView.BEFORE_SHOW = 'beforeShow';
  BaseView.AFTER_SHOW = 'afterShow';
  BaseView.BEFORE_HIDE = 'beforeHide';
  BaseView.AFTER_HIDE = 'afterHide';
  BaseView.BEFORE_RENDER = 'beforeRender';
  BaseView.AFTER_RENDER = 'afterRender';
  BaseView.BEFORE_LOADED = 'beforeLoaded';
  BaseView.AFTER_LOADED = 'afterLoaded';
  BaseView.PROGRESS = 'progress';

  return BaseView;

});
